import { makeStyles } from '@material-ui/core/styles';

import { neutral, red } from 'shared/styles/colors';

export default makeStyles({
  menu: {
    display: 'flex',
    gap: '0.5rem',
  },
  tab: {
    width: '100%',
    listStyle: 'none',
  },
  tabBtnRoot: {
    height: '100%',
    padding: '0.5rem 1rem',
    alignItems: 'flex-start',
    borderRadius: '0.5rem',
    border: `1px solid ${neutral[20]}`,
    '&[aria-selected="true"]': {
      border: `1px solid ${neutral[60]}`,
    },
  },
  tabBtnLabel: {
    display: 'flex',
    gap: '0.25rem',
    flexDirection: 'column',
    textAlign: 'start',
  },
  title: {
    display: 'inline-flex',
    gap: '0.25rem',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral['100'],
  },
  listOfLength: {
    padding: '0 0.25rem',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    borderRadius: '0.5rem',
    color: neutral.white,
    backgroundColor: red['50'],
  },
  description: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[60],
  },
});
